/* eslint-disable @typescript-eslint/no-explicit-any */
import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import {
  NAV_ITEM_LIST,
  NavListItem,
  TAB_MAP,
} from './navigator.component.config';
import { Router } from '@angular/router';
import { AppRoutes } from '@constants';
import { distinctUntilChanged, Subject, takeUntil } from 'rxjs';
import { AgentLogged } from '@interfaces';
import { AuthService } from '@services';
import {
  SharedFunctionService,
  WebsocketHandlerService,
} from 'src/app/core/services/websocket';

@Component({
  selector: 'unicon-navigator',
  templateUrl: './navigator.component.html',
  styleUrl: './navigator.component.scss',
})
export class NavigatorComponent implements OnInit, AfterViewInit, OnDestroy {
  protected navItems: NavListItem[] = NAV_ITEM_LIST;
  private routerEventSubscription!: any;
  protected session!: AgentLogged;
  private destroy$ = new Subject<void>();

  constructor(
    private router: Router,
    private authService: AuthService,
    private sharedFnService: SharedFunctionService,
    private websocket: WebsocketHandlerService,
  ) {
    this.listenEventTabChange();
  }

  ngOnInit(): void {
    this.subscribeRouterEvents();
    this.sharedFnService.setGoRouteCallback(this.goRoute.bind(this));
  }

  ngOnDestroy(): void {
    if (this.routerEventSubscription) {
      this.routerEventSubscription.unsubscribe();
    }
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.setSelectedRoute(this.router.url);
      this.setSessionNames();
    }, 250);
  }

  protected listenEventTabChange() {
    this.websocket
      .listen<any>('TabChangeConfirmed')
      .pipe(takeUntil(this.destroy$))
      .subscribe(([data]) => {
        this.authService.setPreferencesValues(data);
        let tab: string;
        switch (data.currentTab) {
          case 'orders-follow-up':
            tab = AppRoutes.TRACKING;
            break;
          case 'orders-follow-up-chats':
            tab = AppRoutes.CHATS;
            break;
          case 'dashboard':
            tab = AppRoutes.DASHBOARD_TABLE;
            break;
          default:
            tab = AppRoutes.TRACKING;
        }
        this.router.navigate([
          `/${AppRoutes.COMMERTIAL}/${AppRoutes.LEADS}/${tab}`,
        ]);
      });
  }

  private setSessionNames(): void {
    const storedSession: AgentLogged | undefined =
      this.authService.getSessionValues();
    if (storedSession) {
      this.session = storedSession;
    }
  }

  private subscribeRouterEvents(): void {
    this.routerEventSubscription = this.router.events
      .pipe(distinctUntilChanged())
      .subscribe((event: any) => {
        if (event.urlAfterRedirects) {
          this.setSelectedRoute(event.urlAfterRedirects);
        }
      });
  }

  private setSelectedRoute(url: string): void {
    const currentUrl: string[] = url.split('/');
    const validateRoute: string = currentUrl[currentUrl.length - 1];
    this.navItems = this.setActiveRoutes(validateRoute);
  }

  protected goRoute(item: NavListItem): void {
    const mappedTab = TAB_MAP[item.name];

    if (mappedTab) {
      this.websocket.send('OnTabChanged', [mappedTab]);
    }

    if (item.enabled) {
      this.router.navigate([
        `/${AppRoutes.COMMERTIAL}/${AppRoutes.LEADS}/${item.url}`,
      ]);
    }
  }

  private setActiveRoutes(stringToCompare: string): NavListItem[] {
    return this.navItems.map((i: NavListItem) => {
      if (stringToCompare === i.url) {
        i.active = true;
      } else {
        i.active = false;
      }
      return i;
    });
  }

  protected valueReceived(value: number) {
    this.session.statusId = value;
    this.authService.setSessionValues(this.session);
  }
}
